export const sidebarSections = {
    loyalty: 'loyalty-tier',
    menu: 'account-links',
    showcase: 'showcase',
    welcome: 'profile-welcome'
};
